export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 値を配列に正規化する関数
 * - null/undefined → []
 * - 配列 → そのまま
 * - カンマ区切りの文字列 → 配列に変換
 * - その他の値 → []
 * @param {any} value - 正規化する値
 * @returns {Array} 正規化された配列
 */
export const normalizeToArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') {
    return value.split(',').map(v => v.trim()).filter(Boolean);
  }
  return [];
};

/**
 * 全角スペースを半角に変換し、連続する空白を1つに正規化する。
 */
export const normalizeSpaces = (value = '') =>
  value.replace(/\u3000/g, ' ').replace(/ {2,}/g, ' ');